/**
 * @typedef {Object} SocialAction
 * @property {string} iconKey - key mapped to an icon in ViralSocialActions.jsx
 * @property {"blue" | "azure" | "coral" | "cobalt" | "teal"} tint - icon chip + count color token
 * @property {string} label - action label (e.g., "Instagram follow")
 * @property {string} count - signed action count (e.g., "+2,841")
 * @property {boolean} [wide] - span both columns when true
 */

/** @type {SocialAction[]} */
export const socialActions = [
  { iconKey: "instagram", tint: "coral", label: "Instagram follow", count: "+2,841" },
  { iconKey: "facebook", tint: "blue", label: "Facebook share", count: "+1,940" },
  { iconKey: "x", tint: "cobalt", label: "X follow", count: "+1,209" },
  { iconKey: "youtube", tint: "azure", label: "YouTube sub", count: "+874" },
  { iconKey: "mail", tint: "teal", label: "Referrals", count: "+3,162", wide: true },
];

/** @type {string[]} */
export const socialActionBullets = [
  "Compounding reach with no extra ad spend",
  "Bonus entries for Instagram, TikTok, YouTube, X, etc.",
  "Referral mechanics built into every page",
];
